<template>
	<div class="chat-messages-frame">
        <div class="chat__room-title-main">
            <div :class="item.active ? 'chat__room-titleItem chat__room-titleItem-active' : 'chat__room-titleItem'"
                v-for="(item,index) in menuRooms" :key="index" @click="changeRooms(item.idPublic,item.idPrivate, item.teamName, index)">
                <div>{{item.title}}</div>
                <div v-show="item.title === 'МОИ СООБЩЕНИЯ' && getDirectNewMessge > 0" class="chat__room-titleItem-alert">
                </div>
                <div v-show="item.title === 'ОБЩАЯ' && getCommonNewMessge > 0" class="chat__room-titleItem-alert">
                </div>
            </div>
        </div>
        <div class="chat__private-main">
            <div :class="getStatusHeader.header.minimaze ? 'chat__private-zone-main' : 'chat__private-zone-main chat__private-zone-main_headMinimaze'">
                <div class="chat__private-zone-wrap">
                    <template v-for="(msg,index) in orderedMessages">
                        <div class="chat__private-zone-message_card-wrap" :key="index">
                                    <!--<div v-if="msg.t == 'uj'" class="chat__private-zone-message_card-in">
                                        <div class = "chat__private-zone-message_card-text">
                                         User's joined
                                            Пользователь {{msg.u.username}} присоеденился к чату
                                        </div>
                                        <div class="chat__private-zone-message_card-date">
                                            {{$datef(msg.ts.$date)}}
                                        </div>
                                    </div>
                                    <div v-if="msg.t == 'ul'" class="chat__private-zone-message_card-in">
                                        <div class = "chat__private-zone-message_card-text">
                                            User's quit
                                            Пользователь {{msg.u.username}} покинул чат
                                        </div>
                                        <div class="chat__private-zone-message_card-date">
                                            {{$datef(msg.ts.$date)}}
                                        </div>
                                    </div>-->
                                    <transition enter-active-class="animated fadeIn">
                                        <div v-if="!msg.t"
                                            :class="(msg.u.username === getUserLogin && msg.u.username !== 'robot') ? 'chat__private-zone-message_card-out' : 'chat__private-zone-message_card-in'">
                                            <div v-if="msg.u.username === 'robot'" :class="parseMessageRobot(msg.msg).ReportType ? 'chat-robotTitle chat-robotTitle-report' : 'chat-robotTitle'">
                                                <img :src="require('../../assets/img/robot.jpg')"/>
                                                <div class="chat-titleText">
                                                    Сообщение торгового робота
                                                    <div class="chat-robotSubtitle">Торговый робот</div>
                                                </div>
                                            </div>
                                            <!-- Just a message -->
                                            <div v-if="msg.u.username !== 'robot'" class="chat-cardTitle">
                                                <avatar :userLogin="msg.u.username"></avatar>
                                                <div class = "chat__private-zone-message_card-login">
                                                    {{msg.u.name ? msg.u.name : msg.u.username}}
                                                </div>
                                            </div>
                                            <div class = "chat__private-zone-message_card-text">
                                                <div v-if ="msg.u.username !== 'robot'" class="">
                                                    <div v-if="msg.attachments">
                                                        <img @click="showPopup('https://chat.iqquantum.com' + msg.attachments[0].image_url,msg.attachments[0].description)" :src="'https://chat.iqquantum.com' + msg.attachments[0].image_url"/>
                                                        <div class="">{{msg.attachments[0].description }}</div>
                                                    </div>
                                                    {{msg.msg}}
                                                </div>
                                                <robot-msg v-if ="msg.u.username === 'robot'" :msg="parseMessageRobot(msg.msg)" :extendStatus ="true"></robot-msg>
                                            </div>
                                            <div v-if ="msg.u.username !== 'robot'" class="chat__private-zone-message_card-date">
                                                {{$datef(msg.ts.$date)}}
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </template>
                    </div>
                </div>
        </div>
            <div class="chat__private-zone-type__zone">
                    <div class="chat__private-zone-type__zone-textarea">
                        <textarea name="text" rows="1" v-model="textToSend" :placeholder="getLogin !== null ? textPlaceHolder : textNoReg"
                            @focus="onTextChanged()"
                            :class="['message-text', textChanged ? '' : 'message-untouched']" />
                    </div>
                    <div v-if="getLogin !== null && getTypeRoom === true" class="chat__private-zone-type__zone-send__icon">
                        <i class="icon-send"
                            @click="sendMessage()">
                        </i>
                    </div>
            </div>
        <div v-if="showImgPopup" class="chat-imgPopup">
            <div class="chat-closePopup">
                <i @click="closePopup" class="icon-close"></i>
            </div>
            <div class="chat-imgWrap">
                <img :src="imgUrl"/>
                <div class="chat-popupDesc">
                    {{msgImg}}
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { chatMessageStore } from '../../model/chat/chat-message-store.js';
import ChatAvatar from '../ui-components/chat-avatar'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import parseJson from 'parse-json';
import robotMessage from './chat-robot-message';

export default {
	components: {
        "scrollbar":VuePerfectScrollbar,
        "avatar":ChatAvatar,
        "robot-msg":robotMessage
    },
	props: {
    },
	data() {
		return {
			lastCheckedMsgTime: 0,
            messages: {},
            textPlaceHolder: this.$t('Введите текст сообщения...'),
            textToSend: '',
            textRobotsRoom: this.$t('Это канал для сообщений Робота и торговых рекомендаций. Печать сообщений невозможна.'),
            textNoReg: this.$t('Для отправки сообщений в чат необходимо авторизоваться/зерегистрироваться на сайте...'),
			textChanged: false,
            orderedMessages: [],
            imgUrl:null,
            showImgPopup:false,
            msgImg:null,
            menuRooms: [
                {
                    title:'ОБЩАЯ',
                    active:true,
                    idPublic:'chatRooms',
                    idPrivate:'chatPrivateRooms',
                    teamName:'Команда',
                },
                {
                    title:'КОНСУЛЬТАНТЫ',
                    active:false,
                    idPublic:null,
                    idPrivate:'consultPrivateRooms',
                    teamName:'Консультанты',
                },
                {
                    title:'ПАРТНЁРЫ',
                    active:false,
                    idPublic:null,
                    idPrivate:'partnerPrivateRooms',
                    teamName:'ПАРТНЁРЫ',
                },
                {
                    title:'БРОКЕРЫ',
                    active:false,
                    idPublic:null,
                    idPrivate:null,
                    teamName:'БРОКЕРЫ',
                },
                {
                    title:'МОИ СООБЩЕНИЯ',
                    active:false,
                    idPublic:null,
                    idPrivate:'directRoom',
                    teamName:'',
                }
            ]
		};
	},
	computed: {
		...mapGetters({
	        	lastMessageForRoom: 'chatmessage/lastMessageForRoom',
                lastMessageByRoom: 'chatmessage/lastMessageByRoom',
                userRooms:'chat/userRooms',
                infoRoom:'chat/getUsersInRoom',
	        	lastMsgTime: 'chatmessage/lastMsgTime',
                currentRoomId: 'chat/currentRoomId',
                currentRoomName: 'chat/currentRoomName',
                roomMessages: 'chatmessage/roomMessages',
                getLogin: 'auth/getInfoUser',
                getStatusHeader:'usersets/getSettings',
                robotsRooms:'chat/getRoomsForRobots'
            }),
        getUserLogin() {
            if(this.getLogin !== null) {
                return this.getLogin.User.Login.replace(/[@ ,\.]/g,'_');
            } else
            return ' '
        },
        getDirectNewMessge() {
            let directRoom = [];
            let cntNewMessages = 0;
            if (this.infoRoom.length !== 0)
                for(let i = 0; i < this.infoRoom.length; i++) {
                    if(this.infoRoom[i].type === 'd')
                        directRoom.push(this.infoRoom[i]);
                }
            for(let i = 0; i < directRoom.length; i++) {
                if(directRoom[i].newMessages === true)
                    cntNewMessages++;
            }
            return cntNewMessages;
        },
        getCommonNewMessge() {
            let directRoom = [];
            let cntNewMessages = 0;
            if (this.infoRoom.length !== 0)
                for(let i = 0; i < this.infoRoom.length; i++) {
                    if(this.infoRoom[i].type === 'c')
                        directRoom.push(this.infoRoom[i]);
                }
            for(let i = 0; i < directRoom.length; i++) {
                if(directRoom[i].newMessages === true)
                    cntNewMessages++;
            }
            return cntNewMessages;
        },
        getTypeRoom() {
            let type = true;
            for(let i = 0; i < this.robotsRooms.length; i++) {
                if(this.robotsRooms[i] === this.currentRoomId)
                    type = false;
            }
            return type;
        }
	},
	methods: {
		onTextChanged() {
			this.textChanged = true;
			this.textToSend = '';
        },
        showPopup(imgUrl, imgMsg) {
            this.showImgPopup = true;
            this.imgUrl = imgUrl;
            this.msgImg = imgMsg;
        },
        closePopup() {
            this.showImgPopup = false;
        },
		updateMessages() {
			return;
			//console.log(`updating messages since ${this.lastMsgTime}`);
			let messages = chatMessageStore.getRoomsMessages(this.currentRoomId);
			if (!this.messages.length) {
				this.messages = messages;
				return;
            }
        },
        parseMessageRobot(message) {
            let parseMsg  = parseJson(message);
            return parseMsg;
        },
		sendMessage() {
			this.$store.dispatch('chat/sendChatMessage', { msg: this.textToSend, roomId: this.currentRoomId });
            this.textToSend = '';
        },
        changeRooms(publicRooms,privateRooms,team,indexStatus) {
            for(let i = 0; i < this.menuRooms.length; i++) {
                if(i === indexStatus)
                    this.menuRooms[i].active = true;
                else
                   this.menuRooms[i].active = false;
            }
            let rooms = {
                public: publicRooms,
                private: privateRooms,
                nameTeam:team
            }
            this.$emit('changeRooms', rooms);
        }
	},
	watch: {
		roomMessages(newVal, oldVal) {
			let arr = [];
			for (let id in newVal)
				arr.push(newVal[id]);
			arr.sort((a, b) => {
				return a.ts.$date > b.ts.$date ? 1 : a.ts.$date < b.ts.$date ? -1 : 0;
            });
            this.orderedMessages = arr;
        },
        getLogin: function() {
            this.$store.dispatch('chat/enterRoom', 'GENERAL');
            this.$store.commit('chat/setCurrentRoomName', 'ОБЩАЯ');
        },
		lastMsgTime(time, oldVal) {
			//console.log(`lastMessageByRoom: ${this.currentRoomId}`);
			if (!this.currentRoomId) return;
			if (this.lastCheckedMsgTime == time) return;
			this.updateMessages();
			this.lastCheckedMsgTime = time;
        },
        orderedMessages: function (val) {
            this.$nextTick(()=>{
                let container = this.$el.querySelector(".chat__private-zone-main");
                container.scrollTop = container.scrollHeight
            })
        }
    },
    created() {
        this.$store.dispatch('chat/enterRoom', 'GENERAL');
        this.$store.commit('chat/setCurrentRoomName', 'ОБЩАЯ');
    }

};
</script>

<style scoped lang="less">
    textarea::placeholder {
        color:#adc7e1;
    }
    textarea {
        outline: none;
    }
	.chat {
        &__room-titleItem {
            padding: 0px 12px 0px 12px;
            box-sizing: border-box;
            height: 40px;
            align-items: center;
            display: flex;
            &-active {
                background-color: #3d536b;
            }
            &-alert {
                width: 15px;
                height: 15px;
                background: #00ffd0;
                border-radius: 15px;
                margin-left: 8px;
            }
        }
        &-imgPopup {
            width: 100vw;
            height: 100vh;
            background: #000;
            position: fixed;
            top:0;
            left: 0;
            z-index: 9;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }
        &-popupDesc {
            font-family: Roboto;
            font-size: 16px;
            margin-top: 6px;
        }
        &-imgWrap {
            height: 75%;
            width: 75%;
            img {
                width: 100%;
            }
        }
        &-closePopup {
            width: 85%;
            font-size: 37px;
            text-align: right;
            height: 40px;
            i {
                cursor: pointer;
            }
        }
        &-cardTitle {
            display: flex;
            align-items: center;
            padding: 6px 8px 6px 8px;
            img {
                width: 25px;
                height: 25px;
                border-radius: 25px;
                margin-right: 12px;
            }
        }
        &-robotTitle {
            padding: 12px;
            font-family: Arimo;
            font-size: 15px;
            border-bottom: 1px solid #465f7a;
            display: flex;
            color:#adc7e1;
            &-report {
                background: #00ffd0;
                color:#293546;
            }
            img {
                width: 40px;
                height: 40px;
                border-radius: 80px;
                margin-right: 12px;
            }
        }
        &-robotSubtitle {
            font-family: Arimo;
            font-size: 13px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.23;
            color:#fff;
            margin-top: 6px;
        }
        &__room-title-main {
            background: #324258;
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            letter-spacing: 0.4px;
            color: #fff;
            cursor: pointer;
            height: 40px;
            display: flex;
            align-items: center;
        }
        &__private-main {
            display: block;
            position: relative;
        }
        &__private{
            &-zone {
                &-wrap {
                    max-width: 50%;
                    /*padding: 0px 0px 55px;*/

                }
                &-message {
                    &_card-wrap {
                        display: flex;
                        align-items: flex-end;
                    }
                    &_card-in {
                        border-radius: 4px;
                        background-color: #3d536b;
                        margin: 4px 12px 4px 12px;
                    }
                    &_card-out {
                        margin: 4px 12px 4px 12px;
                    }
                    &_card-text {
                        font-family: Roboto;
                        font-size: 15px;
                        font-weight: normal;
                        font-style: normal;
                        font-stretch: normal;
                        line-height: 1.33;
                        letter-spacing: normal;
                        color: #ffffff;
                        padding: 8px 12px 8px 12px;
                    }
                    &_card-login {
						margin-left: 10px;
                        font-family: Roboto;
                        font-size: 15px;
                        font-weight: normal;
                        font-style: normal;
                        font-stretch: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        color: #00ffd0;
                    }
                    &_card-date {
                        font-family: Roboto;
                        font-size: 13px;
                        font-weight: normal;
                        font-style: normal;
                        font-stretch: normal;
                        line-height: 1.54;
                        letter-spacing: normal;
                        color: #adc7e1;
                        display: flex;
                        justify-content: space-between;
                        padding: 0px 12px 8px 12px;
                    }
                }
                &-type__zone {
                    display: flex;
                    justify-content: space-between;
                    padding: 4px 8px;
                    background-color: #3d536b;
                    bottom: 0;
                    min-width: 100%;
                    box-sizing: border-box;
                    box-shadow: 0px -5px 5px 0px rgba(0, 0, 0, 0.2);
                    z-index: 1;
                    &-textarea {
                        flex-grow: 1;
                        margin: 0px 11px;
                        display: flex;
                        textarea {
                            resize: none;
                            width: 100%;
                            background-color: #324258;
                            border-radius: 22px;
                            padding: 12px;
                            box-sizing: border-box;
                            font-family: Roboto;
                            font-size: 15px;
                            font-weight: normal;
                            font-style: normal;
                            font-stretch: normal;
                            line-height: 1.33;
                            letter-spacing: normal;
                            color: #cae4ff;
                            border: none;
                        }
                    }
                    &-send__icon {
                        font-size: 24px;
                        color: #718da8;
                        align-self: flex-end;
                        margin-bottom: 4px;
                        :hover {
                            color: #fff;
                        }
                    }
                }
                &-main {
                    overflow: auto;
                    height: calc(100vh - 190px);
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    background: #313f52;
                    &_headMinimaze {
                         height: calc(100vh - 145px);
                    }

                }
            }

        }
    }
</style>
